import classNames from "classnames";
import styles from "./PreviewPane.module.scss";
import { Tree, Image } from "antd";
import { useEffect, useState } from "react";
// import FileViewer from "react-file-viewer";
import "./custom-tree.css";
// import { findNode } from "@/utils/buildDirectoryTree";
import MdEditor from "@/components/MdEditor";
import CodeFileViewer from "@/components/CodeFileViewer";
import { Spin } from "antd";
import PptPreview from "@/components/PptPreview";
import TifViewer from "@/components/TifViewer";
import PdfViewer from "@/components/PdfViewer";
import WordViewer from "@/components/WordViewer";
import ExcelViewer from "@/components/ExcelViewer";
import { previewPpt, downloadFile, getResourceFileDownloadUrl } from "@/apis/discover";
const { DirectoryTree } = Tree;
// 代码文件扩展名白名单（可扩展）
const CODE_EXTENSIONS = [
  // 前端
  "js",
  "jsx",
  "ts",
  "tsx",
  "mjs",
  "cjs",
  "html",
  "css",
  "scss",
  "sass",
  "less",
  // 后端
  "java",
  "py",
  "go",
  "rb",
  "php",
  "swift",
  "c",
  "cpp",
  "h",
  "hpp",
  "cs",
  "rs",
  // 配置/脚本
  "json",
  "xml",
  "yml",
  "yaml",
  "sh",
  "bat",
  "log",
  "cfg",
  "in",
  "-",
];
// 图片
const IMAGE_EXTENSIONS = [
  "jpg", "jpeg", "png", "gif", "svg", "webp"
]
const PreviewPane = ({ resourceUuid, directoryTree, curData, previewFileData }) => {
  const [treeData, setTreeData] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fileType, setFileType] = useState("");
  const [mdContent, setMdContent] = useState("");
  const [pptImgList, setPptImgList] = useState([]);
  const [error, setError] = useState(null);
  const onSelect = async (key, e) => {
    setSelectedKeys([...key]);
    if (e.node.type === "file") {
      previewFileData(e.node);
      // previewFileFn(e.node);
    }
  };
  useEffect(() => {
    setTreeData(directoryTree);
  }, [directoryTree]);
  useEffect(() => {
    let active = true;
    setFile(null);
    setMdContent("");
    setPptImgList([]);
    setError(null);
    if (!curData) return () => { active = false; };
    const load = async () => {
      setLoading(true);
      const suffix = curData.suffix?.toLowerCase() || "";
      setFileType(suffix);
      try {
        if (suffix === "pptx" || suffix === "ppt") {
          const result = await previewPpt({ resourceUuid, fileUuid: curData.key });
          if (active) setPptImgList(result.data.images);
        } else if (suffix === "md" || suffix === "txt") {
          const result = await downloadFile({ resourceUuid, fileUuid: curData.key });
          if (active) setMdContent(result.data);
        } else {
          const url = await getResourceFileDownloadUrl(resourceUuid, curData.key);
          if (active) setFile(url);
        }
        if (active) setSelectedKeys([curData.key]);
      } catch (error) {
        if (active) setError(error?.response?.data?.msg || error?.msg || error?.message || String(error));
      } finally {
        if (active) setLoading(false);
      }
    };
    load();
    return () => { active = false; };
  }, [curData, resourceUuid]);

  // 错误处理回调函数
  // const handleError = (error) => {
  //   console.error('文档加载失败:', error);
  //   return <div>不支持{fileType}格式预览</div>;
  //   // 这里可以添加用户提示，例如设置状态变量显示错误信息
  // };

  // const onError = () => { };
  // const unsupportedComponent = (e) => {
  //   if (e.filePath) {
  //     return <div>不支持{e.fileType}格式预览</div>;
  //   } else {
  //     return <div>请选择文件进行预览</div>;
  //   }
  // };

  const renderDom = () => {
    if (error) return <div role="alert">{error}</div>;
    if (loading) return null;
    if (CODE_EXTENSIONS.includes(fileType)) {
      return <CodeFileViewer fileType={fileType} url={file} />;
    }else if (fileType === "md" || fileType === "txt") {
      return <MdEditor height={"600px"} textContent={mdContent} />;
    }else if (fileType === "ppt" || fileType === "pptx") {
      return <PptPreview pptImgList={pptImgList} />;
    }else if (fileType.toLowerCase() === "tif" || fileType === "tiff") {
      return <div className={styles.tifBox}>
        <TifViewer tifUrl={file} />
      </div>
    }else if (IMAGE_EXTENSIONS.includes(fileType)) {
      return <div className={styles.imgBox}>
        <Image src={file} />
      </div>
    }else if (fileType === "mp4") {
      return <div className={styles.videoBox}>
        <video className={styles.videoBox} controls src={file} />
      </div>
    }else if (fileType === "pdf") {
      return <PdfViewer
        url={file}
        showDownload={false}        // 是否显示下载按钮
        showFullscreen={true}      // 是否显示全屏按钮
        defaultScale={1.0}         // 默认缩放比例
        minScale={0.5}             // 最小缩放比例
        maxScale={2.0}             // 最大缩放比例
        scaleStep={0.1}           // 缩放步长
      />;
    }else if (fileType === "docx") {
      return <WordViewer
        url={file}              // 文件URL（必填）
        // fileName="报告.docx"       // 文件名（可选）
        showDownload={false}        // 是否显示下载按钮
        height="calc(100vh - 265px)"             // 组件高度
        onError={(err) => { }}      // 错误回调
        onLoad={() => { }}          // 加载完成回调
      />
    }else if (fileType === "xls" || fileType === "xlsx"|| fileType === "csv" || fileType === "ods") {
      return <ExcelViewer
        url={file}              // 文件URL（必填）
        showDownload={false}        // 是否显示下载按钮
        height="calc(100vh - 265px)"             // 组件高度
        maxRows={1000}             // 最大显示行数（防止大文件卡顿）
        onError={(err) => { }}      // 错误回调
        onLoad={() => { }}          // 加载完成回调
      />
    }
    else {
      return <div>暂不支持{fileType}格式的文件在线预览，请下载后查看</div>;
    }
  }

  return (
    <div className={classNames(styles.previewWrap, "flex_box")}>
      <div className={styles.treeWrap}>
        {treeData.length ? (
          <DirectoryTree
            className={classNames("custom-tree")}
            showLine
            fieldNames={{ title: "name" }}
            onSelect={onSelect}
            selectedKeys={selectedKeys}
            defaultExpandedKeys={selectedKeys}
            treeData={treeData}
          />
        ) : (
          ""
        )}
      </div>
      <div className={styles.contentWrap}>
        <Spin spinning={loading}>
          {renderDom()}
        </Spin>
      </div>
    </div>
  );
};

export default PreviewPane;
